import { Badge } from 'reactstrap'
import { getScoreBgColor, getScoreTextColor, getWorkingHoursBgColor, getWorkingHoursTextColor } from 'utility/Utils'

const ScoreBadge = ({ score, size = 'normal', colorType, suffix = '%' }) => {
  const sizeClasses = {
    small: 'px-2 py-1.5 text-xs',
    normal: 'px-3 py-2 text-sm',
    large: 'px-4 py-2.5 text-base font-semibold',
  }

  if (score === 'N/A' || score === null || score === undefined || score === '') {
    return (
      <Badge
        color=""
        pill
        className={`inline-flex items-center ${sizeClasses[size]} font-medium transition-all duration-200`}
        style={{
          backgroundColor: '#f3f4f6',
          color: '#6b7280',
          border: '1px solid #e5e7eb',
        }}
      >
        N/A
      </Badge>
    )
  }

  const bgColor = colorType === 'workingHours' ? getWorkingHoursBgColor(score) : getScoreBgColor(score)
  const textColor = colorType === 'workingHours' ? getWorkingHoursTextColor(score) : getScoreTextColor(score)

  return (
    <Badge
      color=""
      pill
      className={`inline-flex items-center ${sizeClasses[size]} font-medium transition-all duration-200`}
      style={{
        backgroundColor: bgColor,
        color: textColor,
        border: `1px solid ${textColor}20`,
      }}
    >
      {score}{suffix}
    </Badge>
  )
}

export default ScoreBadge
